import * as React from 'react';
import { Image } from '@flightstats/airframe-react';
import styles from './poweredByCirium.module.css';

type BrandingImageProps = {
  url: string;
  [key: string]: any;
};

export const BrandingImage: React.FC<BrandingImageProps> = ({ url, ...rest }) => (
  <Image
    {...rest}
    className={styles.brandingImage}
    src={url}
  />
);